import { render, staticRenderFns } from "./NewLoginOtp.vue?vue&type=template&id=5461f941&"
import script from "./NewLoginOtp.vue?vue&type=script&lang=js&"
export * from "./NewLoginOtp.vue?vue&type=script&lang=js&"
import style0 from "./NewLoginOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports